"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formula = formula;
exports.addFormula = addFormula;

var _moment = _interopRequireDefault(require("moment"));

var formulas = {
  Sum: function Sum() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    return Array.from(params).reduce(function (sum, p) {
      return p + sum;
    });
  },
  Now: function Now() {
    return new Date();
  },
  MomentDiff: function MomentDiff() {
    if ((arguments.length <= 0 ? undefined : arguments[0]) && (arguments.length <= 1 ? undefined : arguments[1])) {
      return (0, _moment.default)(arguments.length <= 0 ? undefined : arguments[0]).diff((0, _moment.default)(arguments.length <= 1 ? undefined : arguments[1]), (arguments.length <= 2 ? undefined : arguments[2]) || 'd');
    }

    return 0;
  },
  MomentAdd: function MomentAdd(d, time, type) {
    if (d) {
      var date = (0, _moment.default)(d);
      date.add(time, type || 'd');
      return date;
    }
  },
  MomentFormat: function MomentFormat(d, format) {
    return d && (0, _moment.default)(d).format(format || 'YYYY-MM-DD');
  },
  DayDiff: function DayDiff() {
    var days = 0;

    if ((arguments.length <= 0 ? undefined : arguments[0]) && (arguments.length <= 1 ? undefined : arguments[1])) {
      days = (0, _moment.default)(arguments.length <= 0 ? undefined : arguments[0]).diff((0, _moment.default)(arguments.length <= 1 ? undefined : arguments[1]), 'd');

      if (days < 0) {
        days = 0;
      } else {
        days += 1;
      }
    }

    return days;
  },
  YearDiff: function YearDiff() {
    return (Number(formulas.DayDiff.apply(formulas, arguments)) / 365.25).toFixed(1);
  },
  IsBefore: function IsBefore() {
    if ((arguments.length <= 0 ? undefined : arguments[0]) && (arguments.length <= 1 ? undefined : arguments[1])) {
      return (0, _moment.default)(arguments.length <= 0 ? undefined : arguments[0]).isBefore((0, _moment.default)(arguments.length <= 1 ? undefined : arguments[1]));
    }
  },
  IfElse: function IfElse() {
    return (arguments.length <= 0 ? undefined : arguments[0]) ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 2 ? undefined : arguments[2];
  },
  Equals: function Equals() {
    return (arguments.length <= 0 ? undefined : arguments[0]) === (arguments.length <= 1 ? undefined : arguments[1]);
  },
  JsonParse: function JsonParse(json) {
    return json && JSON.parse(json);
  },
  Includes: function Includes(p1, p2) {
    return p1 && p2 && p1.includes(p2);
  },
  Or: function Or() {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    return Array.from(params).some(function (p) {
      return !!p;
    });
  },
  And: function And() {
    for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      params[_key3] = arguments[_key3];
    }

    return Array.from(params).every(function (p) {
      return !!p;
    });
  }
};

function formula(funcName) {
  var func = formulas[funcName];

  if (func) {
    for (var _len4 = arguments.length, params = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      params[_key4 - 1] = arguments[_key4];
    }

    return func.apply(void 0, params);
  }

  console.error('Can not find formula name ' + funcName);
}

function addFormula(name, func) {
  formulas[name] = func;
}